import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import AppRoutes from './routes';
import { AppConfig } from './config/Config';
import { AppConfigProvider } from './config/AppConfigProvider';
import { FullScreenSpinner } from './components/Spinners/FullScreenSpinner';
import { StoreVersion } from './features/store_version/components/StoreVersion';

let stripePromise: Promise<Stripe | null>;
let api: {
  version?: string;
  buildDate?: string;
};

async function initAmplify() {
  const cfg = (await AppConfig.getInstance().getConfig()).cognitoConfiguration;

  const cognitoConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId: cfg.aws_user_pools_id!,
        userPoolClientId: cfg.aws_user_pools_web_client_id!
      }
    }
  };

  Amplify.configure(cognitoConfig);

  console.log('[initAmplify] configured:', JSON.stringify(Amplify.getConfig()));
}

async function initStripe() {
  stripePromise = loadStripe(await (await AppConfig.getInstance().getConfig())!.stripeConfiguration!.publishable_key!);
}

async function initApiVersion() {
  const version = (await AppConfig.getInstance().getConfig()).apiVersion;
  const buildDate = (await AppConfig.getInstance().getConfig()).apiBuildDate;

  api = {
    buildDate,
    version
  };
}

async function initDependencies() {
  await initAmplify();

  await initStripe();

  await initApiVersion();
}

function App() {
  const [initializingDependencies, setInitializingDependencies] = useState(true);

  useEffect(() => {
    initDependencies().finally(() => {
      setInitializingDependencies(false);
    });
  }, []);

  if (initializingDependencies) return <FullScreenSpinner></FullScreenSpinner>;

  return (
    <>
      <AppConfigProvider>
        <Authenticator.Provider>
          <Elements stripe={stripePromise}>
            <HelmetProvider>
              <AppRoutes></AppRoutes>
            </HelmetProvider>
          </Elements>
        </Authenticator.Provider>
      </AppConfigProvider>
      <StoreVersion
        store={{ version: process.env.REACT_APP_VERSION, buildDate: process.env.REACT_APP_BUILD_DATE }}
        api={{ version: api.version, buildDate: api.buildDate }}></StoreVersion>
    </>
  );
}

export default App;
